import React, { useEffect, useState } from "react";
import CustomTable from "../../../Components/common/Table/CustomTable";
import { dashboardHeader, latestProfileHeader } from "../../../utils/constants/tableHeaders";
import { useLocation } from "react-router-dom";
import TabButton from "../../../Components/common/TabButton/TabButton";
import Footer from "../../../Components/UI/Footer/Footer";
import ListPopup from "../../../Components/PagesComponents/Dashboard/ListPopup/ListPopup";
import "./styles.scss";

//GET FILE ID IN URL
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const LatestProfile = () => {
  //SET QUERY FOR GETTING DATA ID
  let query = useQuery();
  const [listPopupActive, setListPopupActive] = useState(false);

  useEffect(() => {
    if (query.get("data") !== null) {
      setListPopupActive(true);
    } else {
      setListPopupActive(false);
    }
  }, [query]);
  return (
    <div>
      <div className="profilelatest">
        <div className="profilelatest__body">
          <div
            className="dashboard__table border"
            style={{ width: "100%", minHeight: "763px", marginBottom: "50px", marginTop: "50px" }}>
            <CustomTable
              exportFile={true}
              column={latestProfileHeader}
              tableName={"latest"}
              tableName2={"profile"}
              leftAction={false}
              isSetUrl
              paginationButtons={true}
              className=""
              minBottom="-43px"
              customPageSize={10}
              minHeightRow="72px"
              paginationHeight="36px"
              paginationBackColor="var(--card-background-color)"
              paginationBorder={true}
              manualPagination={true}
            />
          </div>
        </div>
      </div>
      <ListPopup
        onClickOk={() => setListPopupActive(false)}
        show={listPopupActive}
        groupID={query.get("data")}
        tableType={query.get("table")}
        tableType2="profile"
      />
    </div>
  );
};

export default LatestProfile;
